import { DisclosureFormStatus, DisclosureSubmissionStatus, type DisclosureType } from '../enums'

/** An archived form is terminal — there is nothing left to preview or share. */
export const isDisclosureFormPreviewable = (status: DisclosureFormStatus) =>
  status !== DisclosureFormStatus.Archived

/** Only a Draft form may still be edited. */
export const isDisclosureFormLocked = (status: DisclosureFormStatus) =>
  status !== DisclosureFormStatus.Draft

export const isDisclosureFormAcceptingSubmissions = (status: DisclosureFormStatus) =>
  status === DisclosureFormStatus.Published

export const isDisclosureFormOpenForInviteDeletion = (status: DisclosureFormStatus) =>
  status === DisclosureFormStatus.Draft || status === DisclosureFormStatus.Published

/** Disclosure type is the only field required to publish a form. */
export const isDisclosureFormPublishable = (type: DisclosureType | null) => type !== null

export const isDisclosureSubmissionRemindable = ({
  formStatus,
  submissionStatus,
}: {
  formStatus: DisclosureFormStatus
  submissionStatus: DisclosureSubmissionStatus
}) =>
  formStatus === DisclosureFormStatus.Published &&
  submissionStatus === DisclosureSubmissionStatus.Pending

/** Mirrors the backend guard in `DisclosureInviteDeleteService`. */
export const isDisclosureInviteDeletable = ({
  formStatus,
  submissionStatus,
}: {
  formStatus: DisclosureFormStatus
  submissionStatus: DisclosureSubmissionStatus
}) =>
  isDisclosureFormOpenForInviteDeletion(formStatus) &&
  (submissionStatus === DisclosureSubmissionStatus.Pending ||
    submissionStatus === DisclosureSubmissionStatus.DeliveryFailed)
